import { render, staticRenderFns } from "./Invitations.vue?vue&type=template&id=deca9394&scoped=true"
import script from "./Invitations.vue?vue&type=script&lang=js"
export * from "./Invitations.vue?vue&type=script&lang=js"
import style0 from "./Invitations.vue?vue&type=style&index=0&id=deca9394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deca9394",
  null
  
)

export default component.exports